import {
    RiskQuizScoreState,
    RiskQuizAgePortfolio,
    RiskQuizAgeRevision
} from "@/admin/types";
import {
    FetchState
} from "@/shared/types";
import * as drivewealthService from "@/shared/api/drivewealthService";
import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import _ from "lodash";

export const initialState: RiskQuizScoreState = {
    riskQuizAgeRevisionFetchState: FetchState.Uninitialized,
    riskQuizAgePortfolioFetchState: FetchState.Uninitialized,
    riskQuizAgeRevisions: [],
    riskQuizAgePortfolios: []
};

export const useRiskQuizScoreStore = defineStore("riskQuizScore", {
    state: (): RiskQuizScoreState => (_.cloneDeep(initialState)),
    getters: {
        isLoadingRiskQuizAgeRevision: state => state.riskQuizAgeRevisionFetchState === FetchState.Loading,
        didLoadRiskQuizAgeRevision: state => state.riskQuizAgeRevisionFetchState === FetchState.Loaded,
        isLoadingRiskQuizAgePortfolioFetchState: state => state.riskQuizAgePortfolioFetchState === FetchState.Loading,
        didLoadRiskQuizAgePortfolioFetchState: state => state.riskQuizAgePortfolioFetchState === FetchState.Loaded,
    },
    actions: {
        setRiskQuizAgeRevisionFetchState (fetchState: FetchState) {
            this.riskQuizAgeRevisionFetchState = fetchState;
        },
        setRiskQuizAgePortfolioFetchState (fetchState: FetchState) {
            this.riskQuizAgePortfolioFetchState = fetchState;
        },
        setRiskQuizAgeRevisions (collection: RiskQuizAgeRevision[]) {
            this.riskQuizAgeRevisions = collection;
        },
        setRiskQuizAgePortfolios (collection: RiskQuizAgePortfolio[]) {
            this.riskQuizAgePortfolios = collection;
        },
        loadRiskQuizAgeRevisions (): Promise<any> {
            if (this.riskQuizAgeRevisionFetchState !== FetchState.Uninitialized) {
                return Promise.resolve();
            }
            this.setRiskQuizAgeRevisionFetchState(FetchState.Loading);
            return drivewealthService.getRiskQuizAgeRevisions()
                .then(response => {
                    this.setRiskQuizAgeRevisions(response.data);
                    this.setRiskQuizAgeRevisionFetchState(FetchState.Loaded);
                })
                .catch(err => {
                    this.setRiskQuizAgeRevisionFetchState(FetchState.Uninitialized);
                    return storeHelper.handleError({ error: err, rethrow: true });
                });
        },
        loadRiskQuizAgePortfolios (): Promise<any> {
            if (this.riskQuizAgePortfolioFetchState !== FetchState.Uninitialized) {
                return Promise.resolve();
            }
            this.setRiskQuizAgePortfolioFetchState(FetchState.Loading);
            return drivewealthService.getRiskQuizAgePortfolios()
                .then(response => {
                    this.setRiskQuizAgePortfolios(response.data);
                    this.setRiskQuizAgePortfolioFetchState(FetchState.Loaded);
                })
                .catch(err => {
                    this.setRiskQuizAgePortfolioFetchState(FetchState.Uninitialized);
                    return storeHelper.handleError({ error: err, rethrow: true });
                });
        },
        processRiskQuizAgeRevisionFile ({ csv }) {
            return drivewealthService.processRiskQuizAgeRevisionFile(csv)
                .then(() => {
                    this.setRiskQuizAgeRevisionFetchState(FetchState.Uninitialized);
                })
                .catch(err => storeHelper.handleError({ error: err, rethrow: true }));
        },
        processRiskQuizAgePortfolioFile ({ csv }) {
            return drivewealthService.processRiskQuizAgePortfolioFile(csv)
                .then(() => {
                    this.setRiskQuizAgePortfolioFetchState(FetchState.Uninitialized);
                })
                .catch(err => storeHelper.handleError({ error: err, rethrow: true }));
        },
    }
});